import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks/useRequest";
import {
  IDeliveryBarcodeHistoryDetail,
  IGetDeliveryBarcodeHistoryDetailRequest,
  IPaginateApiResponse,
} from "model";
import React, { useEffect, useState } from "react";
import { PalletApiService, ReportApiService } from "services";
import { I18nTranslator, translations } from "utils/i18n";
import { useDeliveryHistoryContext } from "..";

interface ILocationListProps {
  request: IGetDeliveryBarcodeHistoryDetailRequest;
  loading: boolean;
  result: IPaginateApiResponse<IDeliveryBarcodeHistoryDetail[]>;
}

const QRCodeList = (props: ILocationListProps) => {
  const { request, loading, result } = props;
  const {
    handleQRCodeListChangePage,
    handleCodeListPageSizeChange,
    handleSearchQRCodeList,
  } = useDeliveryHistoryContext();
  const [getFinishProductList, setFinishProductList] = useState(request);
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (!initialLoad) {
      setFinishProductList(request);
    }
  }, [request]);

  const handleChangePage = (pageNumber: number) => {
    setFinishProductList({
      ...request,
      pageNumber: pageNumber,
    });
  };
  const handlePageSizeChange = (pageSize: number) => {
    setFinishProductList({ ...request, pageSize: pageSize });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "strDeliveryDate",
      headerName: I18nTranslator(translations.report.deliveryDate),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "doImportCode",
      headerName: I18nTranslator(translations.report.DOImportCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.report.companyCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.report.companyName),
      size: "full",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.report.productLot),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productDescription",
      headerName: I18nTranslator(translations.report.productName),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "cartonBarcode",
      headerName: I18nTranslator(translations.report.cartonCode),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productBarcode",
      headerName: I18nTranslator(translations.report.productBarcode),
      size: "medium",
      align: "left",
    }),
  ];

  return (
    <AppTable<IDeliveryBarcodeHistoryDetail>
      loading={loading}
      data={result}
      columns={COLUMNS}
      actionColumnProps={{
        hideEdit: true,
      }}
      onSearch={handleSearchQRCodeList}
      searchPlaceholder={"Tìm kiếm"}
      onChangePage={handleQRCodeListChangePage}
      hideHeader
      removeActionColumn
      defaultHeaderTable={210}
      onPageSizeChange={handleCodeListPageSizeChange}
      hideSearch
    />
  );
};

export default QRCodeList;
